// Mirrors src/Kes.Rewards.Domain/Drawings/PrizeDisplay.cs. Prize value is admin-only; the shop display
// never shows it, and dollar amounts typed into the prize name are removed before the TV shows the name.
const MONEY = /(?:US)?\$\s*\d[\d,]*(?:\.\d+)?\s*[kK]?|\b\d[\d,]*(?:\.\d+)?\s*(?:USD|dollars?|bucks)\b|\bUSD\s*\d[\d,]*(?:\.\d+)?/gi;

export function prizeDisplayName(prizeName: string | null | undefined): string {
  if (!prizeName || !prizeName.trim()) return 'Prize';
  const s = prizeName
    .replace(MONEY, ' ')
    .replace(/[([]\s*[)\]]/g, ' ')
    .replace(/\s{2,}/g, ' ')
    .replace(/^[\s\-–—•:,/|]+|[\s\-–—•:,/|]+$/g, '')
    .trim();
  return s.length === 0 ? 'Prize' : s;
}
